<qv-review-drug-menu *ngIf="isReviewMode"></qv-review-drug-menu>
<qv-drug-actions-menu *ngIf="!isReviewMode"
                      [bidVersionId]="bidVersionId"
                      [cbId]="cbId"
                      [isBidInternal]="isBidInternal"
                      [pharmaId]="pharmaId"
></qv-drug-actions-menu>
